module.exports = __webpack_public_path__ + "img/8c81984f07c87af845a9df60ea7a3641.png";